<template>
  <EditForm :organization="organization" :editing="true"/>
</template>

<script>
import EditForm from '@/pages/admin/organization/EditForm'
import OrganizationService from '@/services/OrganizationService'

export default {
  props: {
    id: String
  },
  components: {EditForm},
  data: () => ({
    organization: OrganizationService.getDefaultItem(),
    organizationService: undefined
  }),
  computed: {},
  created () {
    this.organizationService = new OrganizationService(this.$store)
    this.organizationService.getItem(this.id, (data) => {
      this.organization = data.item
    })
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/organization/Edit.vue